<template>
    <div class="modal fade" id="div-otp-input-result" tabindex="-1" aria-labelledby="informLabel" aria-hidden="true">
        <div class="modal-dialog" v-if="this.params.result">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-center w-100 pl-4 pr-4">{{$t('MSG_TRS_NAF_0201')}}</h4>
                    <button type="button" class="close modal-close-btn" data-dismiss="modal" aria-label="Close" @click="clickCloseAfterSuccessfully()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center pt-0">
                    <img src="@/assets/img/register-passkey-successfully.png" width="56px"/>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100 justify-content-center">
                        <div class="col-12 col-sm-6 w-100">
                            <button type="button" class="btn btn-sm btn-primary w-100" @click="clickCloseAfterSuccessfully()">OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import ServiceUtils from '@/common/utils/ServiceUtils';

    export default {
        name: "OtpInputResult",
        data() {
            return {
                params: {
                    result: true,
                }
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_OTP_INPUT_RESULT, (params) => {
                    $('#div-otp-input-result').modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-otp-input-result").modal("show");
                });
            },
            async clickCloseAfterSuccessfully() {
                await ServiceUtils.waitModalFullyHidden($("#div-otp-input-result"));
                this.$modal.closeOtpInputResult();
            },
        }
    }
</script>

<style scoped>
    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }
</style>
